import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import {educationPhaseOptions} from 'src/constants';
import FormikDropdown from 'src/components/formik-dropdown';
import {titleize} from 'shared/utils';

const EducationPhaseSelection = (): React.ReactElement => (
  <FormikDropdown options={educationPhaseOptions} name="educationPhase" />
);

const columns: ColumnSettings[] = [
  {
    name: 'name',
    title: 'Name',
    sortable: true,
  },
  {
    name: 'issuer',
    title: 'Issuer',
    sortable: true,
  },
  {
    name: 'educationPhase',
    title: 'Education Phase',
    FormField: EducationPhaseSelection,
    renderValue: (value: string | number | string[]): string => {
      if (Array.isArray(value)) value = value.join(', ');
      return titleize((value + '').replace('-', ' '));
    },
  },
];

const HonorAwards = (): React.ReactElement => (
  <div>
    <h1 className="shared-font headline">Honors and Awards</h1>
    <EditableTable
      basePath="/v1/admin/honor-awards"
      defaultSortKey="name"
      columns={columns}
      identifier="honor-awards"
    />
  </div>
);

export default HonorAwards;
